import { Layout } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { logout } from "../../api/auth";
import { ChangePasswordModal } from "../auth/ChangePasswordModal";
import { useAuth } from "../auth/AuthContext";
import { AppHeader } from "./AppHeader";

const { Content } = Layout;

export function AppShell() {
  const auth = useAuth();
  const user = auth.user!;
  const [passwordModalOpen, setPasswordModalOpen] = useState(user.must_change_password);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const logoutMutation = useMutation({
    mutationFn: logout,
    onSettled: async () => {
      auth.clear();
      queryClient.removeQueries({
        predicate: (query) => query.queryKey[0] !== "current-user",
      });
      await navigate("/login", { replace: true });
    },
  });

  return (
    <Layout className="app-layout">
      <AppHeader
        user={user}
        logoutPending={logoutMutation.isPending}
        onChangePassword={() => setPasswordModalOpen(true)}
        onLogout={() => logoutMutation.mutate()}
      />

      <Content className="app-content">
        <Outlet />
      </Content>
      <ChangePasswordModal
        open={passwordModalOpen || user.must_change_password}
        required={user.must_change_password}
        onClose={() => setPasswordModalOpen(false)}
      />
    </Layout>
  );
}
